import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TaxCategoryValueObject  {
    _originalTypeClassName = "zERP.BO.TaxCategoryValueObject";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TaxCategoryValueObject.translate = translateService;
}
this.Id = null;
this.Name = null;
this.MyDataCode = null;
this.Code = null;
this.Type = null;
this.Description = null;
this.Amount = null;
this.IsPercent = false;
this.Notes = null;
this.WithinBudget = false;
this.IsAttributed = false;
this.SubjectToVAT = false;
this.PaymentUsingEAP = false;
this.EAPCode = null;
this.WithinDeductionInvoices = false;
this.ReducesReceivable = false;
this.IsPrepaid = false;
this.ManuallySetAmount = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
MyDataCode:any;
Code:any;
Type:any;
Description:any;
Amount:any;
IsPercent:any;
Notes:any;
WithinBudget:any;
IsAttributed:any;
SubjectToVAT:any;
PaymentUsingEAP:any;
EAPCode:any;
WithinDeductionInvoices:any;
ReducesReceivable:any;
IsPrepaid:any;
ManuallySetAmount:any;
IncomeAccount:any;
ExpenseAccount:any;
AccountingConfig:any;
Treasury:any;
AADECode:any;
static setIncomeAccount = ($this, value) => {
var oldValue = $this.IncomeAccount;
$this.IncomeAccount = value;
if (value != null) {
}
}
static setExpenseAccount = ($this, value) => {
var oldValue = $this.ExpenseAccount;
$this.ExpenseAccount = value;
if (value != null) {
}
}
static setAccountingConfig = ($this, value) => {
var oldValue = $this.AccountingConfig;
$this.AccountingConfig = value;
if (value != null) {
}
}
static setTreasury = ($this, value) => {
var oldValue = $this.Treasury;
$this.Treasury = value;
if (value != null) {
}
}
static setAADECode = ($this, value) => {
var oldValue = $this.AADECode;
$this.AADECode = value;
if (value != null) {
}
}

static CalculateAmount($this: any, amountToApplyTo: any): any{if ($this?.IsPercent) {return Joove.Common.safeNumber(amountToApplyTo) * Joove.Common.safeNumber((Joove.Common.safeNumber($this?.Amount) / Joove.Common.safeNumber(100)));}
return $this?.Amount;
}
static FeesTaxCodeToAmount($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return 12;}
case 2:
{
return 15;}
case 3:
{
return 18;}
case 4:
{
return 20;}
case 5:
{
return 12;}
case 6:
{
return 10;}
case 7:
{
return 5;}
case 8:
{
return null;}
case 9:
{
return 2;}
case 10:
{
return null;}
case 11:
{
return null;}
case 12:
{
return null;}
case 13:
{
return 10;}
case 14:
{
return 10;}
case 15:
{
return 0;}
case 16:
{
return null;}
case 17:
{
return null;}
case 18:
{
return null;}
case 19:
{
return null;}
case 20:
{
return null;}
case 21:
{
return null;}
case 22:
{
return null;}
default:
{
return 0;}
}
}
static FeesTaxCodeToDescription($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return "Για μηνιαίο λογαριασμό μέχρι και 50 ευρώ 12%";}
case 2:
{
return "Για μηνιαίο λογαριασμό από 50,01 μέχρι και 100 ευρώ 15%";}
case 3:
{
return "Για μηνιαίο λογαριασμό από 100,01 μέχρι και 150 ευρώ 18%";}
case 4:
{
return "Για μηνιαίο λογαριασμό από 150,01 ευρώ και άνω 20%";}
case 5:
{
return "Τέλος καρτοκινητής επί της αξίας του χρόνου ομιλίας (12%)";}
case 6:
{
return "Τέλος στη συνδρομητική τηλεόραση 10%";}
case 7:
{
return "Τέλος συνδρομητών σταθερής τηλεφωνίας 5%";}
case 8:
{
return "Περιβαλλοντικό Τέλος & πλαστικής σακούλας ν. 2339/2001 αρ. 6α 0,07 ευρώ ανά τεμάχιο";}
case 9:
{
return "Εισφορά δακοκτονίας 2%";}
case 10:
{
return "Λοιπά τέλη";}
case 11:
{
return "Τέλη Λοιπών Φόρων";}
case 12:
{
return "Εισφορά δακοκτονίας";}
case 13:
{
return "Για μηνιαίο λογαριασμό κάθε σύνδεσης (10%)";}
case 14:
{
return "Τέλος καρτοκινητής επί της αξίας του χρόνου ομιλίας (10%)";}
case 15:
{
return "Τέλος κινητής και καρτοκινητής για φυσικά πρόσωπα ηλικίας 15 έως και 29 ετών (0%)";}
case 16:
{
return "Εισφορά προστασίας περιβάλλοντος πλαστικών προϊόντων 0,04 λεπτά ανά τεμάχιο [άρθρο 4 ν. 4736/2020]";}
case 17:
{
return "Τέλος ανακύκλωσης 0,08 λεπτά ανά τεμάχιο [άρθρο 80 ν. 4819/2021]";}
case 18:
{
return "Τέλος διαμονής παρεπιδημούντων";}
case 19:
{
return "Tέλος επί των ακαθάριστων εσόδων των εστιατορίων και συναφών καταστημάτων";}
case 20:
{
return "Τέλος επί των ακαθάριστων εσόδων των κέντρων διασκέδασης";}
case 21:
{
return "Τέλος επί των ακαθάριστων εσόδων των καζίνο";}
case 22:
{
return "Λοιπά τέλη επί των ακαθάριστων εσόδων";}
default:
{
return "";}
}
}
static FeesTaxToIsPercent($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return true;}
case 2:
{
return true;}
case 3:
{
return true;}
case 4:
{
return true;}
case 5:
{
return true;}
case 6:
{
return true;}
case 7:
{
return true;}
case 8:
{
return false;}
case 9:
{
return true;}
case 10:
{
return false;}
case 11:
{
return false;}
case 12:
{
return false;}
case 13:
{
return true;}
case 14:
{
return true;}
case 15:
{
return true;}
case 16:
{
return false;}
case 17:
{
return false;}
case 18:
{
return false;}
case 19:
{
return false;}
case 20:
{
return false;}
case 21:
{
return false;}
case 22:
{
return false;}
default:
{
return true;}
}
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static OtherTaxCodeToAmount($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return 15;}
case 2:
{
return 5;}
case 3:
{
return 4;}
case 4:
{
return 15;}
case 5:
{
return 0;}
case 6:
{
return 0.50;}
case 7:
{
return 1.50;}
case 8:
{
return 3.00;}
case 9:
{
return 4.00;}
case 10:
{
return 0.50;}
case 11:
{
return 5;}
case 12:
{
return 10;}
case 13:
{
return 10;}
case 14:
{
return 80;}
case 15:
{
return 20;}
case 16:
{
return null;}
case 17:
{
return null;}
case 18:
{
return null;}
case 19:
{
return null;}
default:
{
return 0;}
}
}
static OtherTaxCodeToDescription($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return "α1) ασφάλιστρα κλάδου πυρός 20%";}
case 2:
{
return "α2) ασφάλιστρα κλάδου πυρός 20%";}
case 3:
{
return "β) ασφάλιστρα κλάδου ζωής 4%";}
case 4:
{
return "γ) ασφάλιστρα λοιπών κλάδων 15%.";}
case 5:
{
return "δ) απαλλασσόμενα φόρου ασφαλίστρων 0%.";}
case 6:
{
return "Ξενοδοχεία 1-2 αστέρων 0,50 €";}
case 7:
{
return "Ξενοδοχεία 3 αστέρων 1,50 €";}
case 8:
{
return "Ξενοδοχεία 4 αστέρων 3,00 €";}
case 9:
{
return "Ξενοδοχεία 4 αστέρων 4,00 €";}
case 10:
{
return "Ενοικιαζόμενα - επιπλωμένα δωμάτια - διαμερίσματα 0,50 €";}
case 11:
{
return "Ειδικός Φόρος στις διαφημίσεις που προβάλλονται από την τηλεόραση (ΕΦΤΔ) 5%";}
case 12:
{
return "3.1 Φόρος πολυτελείας 10% επί της φορολογητέας αξίας για τα ενδοκοινοτικώς αποκτούμενα και εισαγόμενα από τρίτες χώρες 10%";}
case 13:
{
return "3.2 Φόρος πολυτελείας 10% επί της τιμής πώλησης προ Φ.Π.Α. για τα εγχωρίως παραγόμενα είδη 10%";}
case 14:
{
return "Δικαίωμα του Δημοσίου στα εισιτήρια των καζίνο (80% επί του εισιτηρίου)";}
case 15:
{
return "ασφάλιστρα κλάδου πυρός 20%";}
case 16:
{
return "Λοιποί Τελωνειακοί Δασμοί-Φόροι";}
case 17:
{
return "Λοιποί Φόροι";}
case 18:
{
return "Επιβαρύνσεις Λοιπών Φόρων";}
case 19:
{
return "ΕΦΚ";}
default:
{
return "";}
}
}
static OtherTaxCodeToIsPercent($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return true;}
case 2:
{
return true;}
case 3:
{
return true;}
case 4:
{
return true;}
case 5:
{
return true;}
case 6:
{
return false;}
case 7:
{
return false;}
case 8:
{
return false;}
case 9:
{
return false;}
case 10:
{
return false;}
case 11:
{
return true;}
case 12:
{
return true;}
case 13:
{
return true;}
case 14:
{
return true;}
case 15:
{
return true;}
case 16:
{
return false;}
case 17:
{
return false;}
case 18:
{
return false;}
case 19:
{
return false;}
default:
{
return true;}
}
}
static StampDutyTaxCodeToDescription($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return "Συντελεστής 1,2 %";}
case 2:
{
return "Συντελεστής 2,4 %";}
case 3:
{
return "Συντελεστής 3,6 %";}
case 4:
{
return "Λοιπές περιπτώσεις Χαρτοσήμου";}
default:
{
return "";}
}
}
static StampDutyTaxToAmount($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return 1.20;}
case 2:
{
return 2.40;}
case 3:
{
return 3.60;}
case 4:
{
return null;}
default:
{
return null;}
}
}
static StampDutyToIsPercent($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return true;}
case 2:
{
return true;}
case 3:
{
return true;}
case 4:
{
return false;}
default:
{
return true;}
}
}
static WithheldTaxCodeToAmount($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return 15;}
case 2:
{
return 20;}
case 3:
{
return 20;}
case 4:
{
return 3;}
case 5:
{
return 1;}
case 6:
{
return 4;}
case 7:
{
return 8;}
case 8:
{
return 4;}
case 9:
{
return 10;}
case 10:
{
return 15;}
case 11:
{
return null;}
case 12:
{
return 15;}
case 13:
{
return 10;}
case 14:
{
return null;}
case 15:
{
return null;}
case 16:
{
return null;}
case 17:
{
return null;}
case 18:
{
return 5;}
default:
{
return 0;}
}
}
static WithheldTaxCodeToDescription($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return "Περιπτ. β’- Τόκοι - 15%";}
case 2:
{
return "Περιπτ. γ’ - Δικαιώματα - 20%";}
case 3:
{
return "Περιπτ. δ’ - Αμοιβές Συμβουλών Διοίκησης - 20%";}
case 4:
{
return "Περιπτ. δ’ - Τεχνικά Έργα - 3%";}
case 5:
{
return "Υγρά καύσιμα και προϊόντα καπνοβιομηχανίας 1%";}
case 6:
{
return "Λοιπά Αγαθά 4%";}
case 7:
{
return "Παροχή Υπηρεσιών 8%";}
case 8:
{
return "Προκαταβλητέος Φόρος Αρχιτεκτόνων και Μηχανικών επί Συμβατικών Αμοιβών, για Εκπόνηση Μελετών και Σχεδίων 4%";}
case 9:
{
return "Προκαταβλητέος Φόρος Αρχιτεκτόνων και Μηχανικών επί Συμβατικών Αμοιβών, που αφορούν οποιασδήποτε άλλης φύσης έργα 10%";}
case 10:
{
return "Προκαταβλητέος Φόρος στις Αμοιβές Δικηγόρων 15%";}
case 11:
{
return "Παρακράτηση Φόρου Μισθωτών Υπηρεσιών παρ. 1 αρ. 15 ν. 4172/2013";}
case 12:
{
return "Παρακράτηση Φόρου Μισθωτών Υπηρεσιών παρ. 2 αρ. 15 ν. 4172/2013 - Αξιωματικών Εμπορικού Ναυτικού";}
case 13:
{
return "Παρακράτηση Φόρου Μισθωτών Υπηρεσιών παρ. 2 αρ. 15 ν. 4172/2013 - Κατώτερο Πλήρωμα Εμπορικού Ναυτικού";}
case 14:
{
return "Παρακράτηση Ειδικής Εισφοράς Αλληλεγγύης";}
case 15:
{
return "Παρακράτηση Φόρου Αποζημίωσης λόγω Διακοπής Σχέσης Εργασίας παρ.3 αρ. 15 ν. 4172/2013";}
case 16:
{
return "Παρακρατήσεις συναλλαγών αλλοδαπής βάσει συμβάσεων αποφυγής διπλής φορολογίας (Σ.Α.Δ.Φ.)";}
case 17:
{
return "Λοιπές Παρακρατήσεις Φόρου";}
case 18:
{
return "Παρακράτηση Φόρου Μερίσματα περ.α παρ. 1 αρ. 64 ν. 4172/2013";}
default:
{
return "";}
}
}
static WithheldTaxToIsPercent($this: any): any{switch ($this?.MyDataCode) {case 1:
{
return true;}
case 2:
{
return true;}
case 3:
{
return true;}
case 4:
{
return true;}
case 5:
{
return true;}
case 6:
{
return true;}
case 7:
{
return true;}
case 8:
{
return true;}
case 9:
{
return true;}
case 10:
{
return true;}
case 11:
{
return false;}
case 12:
{
return true;}
case 13:
{
return true;}
case 14:
{
return false;}
case 15:
{
return false;}
case 16:
{
return false;}
case 17:
{
return false;}
case 18:
{
return true;}
default:
{
return true;}
}
}
static WithheldTaxToIsPrepaid($this: any): any{switch ($this?.MyDataCode) {case 8:
case 9:
case 10:
{
return true;}
default:
{
return false;}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}